/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface WebhookWhatsappStatusRequestParams {
    xHubSignature256?: string;
    body?: string;
}

export interface WebhookWhatsappVerifyRequestParams {
    hubMode: string;
    hubChallenge: string;
    hubVerifyToken: string;
}


export interface WhatsAppWebhookServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Meta WhatsApp webhook status callback (POST)
     * Riceve i cambi di stato dei messaggi outbound. Body firmato HMAC SHA256.
     * @endpoint post /api/v1/webhooks/whatsapp
* @param requestParameters
     */
    webhookWhatsappStatus(requestParameters: WebhookWhatsappStatusRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Meta WhatsApp webhook verify (GET)
     * Handshake di sottoscrizione: confronta hub.verify_token col valore configurato e ritorna hub.challenge.
     * @endpoint get /api/v1/webhooks/whatsapp
* @param requestParameters
     */
    webhookWhatsappVerify(requestParameters: WebhookWhatsappVerifyRequestParams, extraHttpRequestParams?: any): Observable<string>;

}
